import React from 'react';

import NavigationBar from '../components/NavigationBar';
import Footer from '../components/Footer/Footer';
import Menus from '../components/Menus';
import StatDayVisits from '../components/StatDayVisits';
import StatDayVisitors from '../components/StatDayVisitors';
import StatMonthVisits from '../components/StatMonthVisits';
import StatMonthVisitors from '../components/StatMonthVisitors';

function Statistics() {

    return (
        <div>
            <NavigationBar />
            <h1>Statistiques</h1>
            <div className="p-3">
                <StatDayVisits />
                <StatDayVisitors />
                <StatMonthVisits />
                <StatMonthVisitors />
            </div>
            <Menus />
            <Footer />
        </div>
    );
}

export default Statistics;